import api from '@/api'

const { $student } = api;

export const { $studentListContracts, $studentDownloadContract} = $student;
